import { Pipe, PipeTransform } from '@angular/core';
import { HotelAvalibilityQuoteResult } from '@sabstravtech/obtservices/base';

@Pipe({
  name: 'hotelRoomsPrice',
  standalone: false
})
export class HotelRoomsPricePipe implements PipeTransform {
  transform(rooms: HotelAvalibilityQuoteResult, noOfRooms: number): number {
    if (rooms && rooms?.rooms?.length >= 1) {
      const roomsWithMinPrice = rooms.rooms.filter((room) => room.total === rooms.minprice);
      const minTotal = roomsWithMinPrice.length ? rooms.minprice : rooms.rooms[0].total;
      const minPrpn = roomsWithMinPrice.length ? rooms.prpn : rooms.rooms[0].prpn;
      return noOfRooms ? minTotal * noOfRooms : minPrpn;
    }
  }
}
